import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

import { Button } from '@/slw/shared/ui/button';
import FormProvider, { Input } from '@/slw/shared/ui/form';

const schema = z.object({
  email: z.string().min(1, 'Email is required').email('Invalid email address'),
});

export function EmailStep({ onSubmit, loading }: { onSubmit: (email: string) => void; loading: boolean }) {
  const methods = useForm<{ email: string }>({
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...methods} onSubmit={(v) => onSubmit(v.email)} className='w-full flex flex-col justify-center'>
      <div className='mb-4'>
        <Input
          direction='column'
          required
          id='email'
          name='email'
          label='Your email'
          placeholder='Enter your email address'
          helperText=''
        />
      </div>
      <Button type='submit' disabled={loading} className='w-full'>
        {loading ? 'Loading...' : 'CONTINUE'}
      </Button>
    </FormProvider>
  );
}
